export const unitNames = 
[
    'Introduction to Supervised Learning and Neural Networks',
    'Unsupervised Learning and Reinforcement Learning',
    'Deep Learning Architectures and Methods',
    'Applications',
    'Paper Reading Blog'
]
export const overview = [
    (
        <div className="card">
            Machine learning algorithms learn from the training data and adjust 
            based on feedback. The simplest type of learning is supervised 
            learning, which is when a model trains on a labeled dataset to 
            predict outputs given a set of inputs.
        </div>
    ),
    (
        <div className="card">
            Unit 1 covered supervised learning, which requires labeled datasets.
            However, a significant limitation on using labeled datasets is that 
            labeling is expensive and not always feasible. As a result, there is 
            much more unlabeled data than labeled data. This section covers learning 
            methods that can be used with limited or no labeled data.
        </div>
    ),
    (
        <div className="card">
            Not every neural network is a simple multilayer perceptron.
            Different types of networks have been developed to learn different 
            kinds of patterns. In this section, we discuss new architectures, 
            many of which come from computer vision or natural langauge processing.
        </div>
    ),
    (
        <div className="card">
            AI has tons of applications. This is not a comprehensive list, and more
            applications will be added in the future.
        </div>
    ),
    (
        <div className="card">
            In this section I'll share some papers/books I've found interesting. 
            If you catch any mistakes, please email me!
        </div>
    )
]